/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Input, Modal, notification, Row, Select } from 'antd';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { OnFetchShipmentSno } from '../../redux/ShipmentDetails/saga';
import { OnAddorUpdateShipmentsDashboard } from '../../redux/ShipmentDashboardDetails/saga';

const { Option } = Select;

const AddNewShipments = (props) => {
  const {
    showAddModel,
    setShowAddModel,
    editRecord,
    isEdit,
    setIsEdit,
    OnfetchData,
    selectedProject,
    adminShipmentTypesList,
  } = props;

  const [shipmentType, setShipmentType] = useState('');
  const [ShipmentNumber, setShipmentNumber] = useState('');
  const [addLoading, setAddLoading] = useState(false);
  const [equipTypeForm] = Form.useForm();

  //setting admin equipment details
  const [adminEquipmentTypes, setAdminEquipmentTypes] = useState([]);
  const [serialNo, setSerialNo] = useState('');
  const [serialNoList, setSerialNoList] = useState([]);

  const [pihEquipment, setPihEquipment] = useState('');
  const [shipmentTyCategory, setShipmentTypeCategory] = useState('');
  const [serialNoLoading, setSerialNoLoading] = useState(false);

  useEffect(() => {
    console.log(editRecord, isEdit, adminShipmentTypesList);
    if (isEdit && editRecord) {
      // setShipmentType(editRecord.shipmentTypeName)
      onChangeShipmentType(editRecord.shipmentTypeName);
      onChangeShipmentSerialNumber(editRecord.shipmentNumber);
    }
  }, [isEdit]);

  /** On change function to select Category */
  const onChangeShipmentType = async (value) => {
    setSerialNo('');
    setPihEquipment('');
    setAdminEquipmentTypes([]);
    if (value) {
      setShipmentTypeCategory(value);
      var shipmentArr =
        adminShipmentTypesList && adminShipmentTypesList.filter((item) => item.name == value);

      if (shipmentArr && shipmentArr.length > 0) {
        setShipmentNumber('');
        setSerialNoList([]);
        setSerialNo('');
        setShipmentTypeCategory(shipmentArr[0]);
        await OnfetchSerialNumberData(shipmentArr[0]);
      } else {
        setShipmentTypeCategory('');
        setShipmentType('');
        setShipmentNumber('');
        setSerialNoList([]);
        setSerialNo('');
      }
    } else {
      setShipmentTypeCategory('');
      setShipmentType('');
      setShipmentNumber('');
      setSerialNoList([]);
      setSerialNo('');
    }
  };
  /** On change function to select Category */
  const onChangeShipmentSerialNumber = async (value) => {
    if (value) {
      setShipmentNumber(value);
      var shipmentNumber =
        serialNoList && serialNoList.filter((item) => item.shipmentNumber == value);
      //  console.log(shipmentNumber)

      if (shipmentNumber && shipmentNumber.length > 0) {
        setSerialNo(shipmentNumber[0]);
      }
    } else {
      setSerialNo('');
      setShipmentNumber('');
    }
  };
  const OnfetchSerialNumberData = async (selectedShipmentType) => {
    setSerialNoLoading(true);
    const obj = {
      id: selectedShipmentType.id,
    };
    setShipmentType(selectedShipmentType.name);
    const res = await OnFetchShipmentSno(obj, 'false');
    if (res['shipmentType']?.shipments && res['shipmentType'].shipments.length > 0) {
      setSerialNoList(res['shipmentType'].shipments);
    }
    setSerialNoLoading(false);
  };

  /** Adding or Updating Equipment types */
  const handleOk = async () => {
    if (shipmentTyCategory == '') {
      notification.warning({
        message: 'Please select shipment type to proceed!',
      });
      return;
    } else if (serialNo == '') {
      notification.warning({
        message: 'Please select shipment number to proceed!',
      });
      return;
    }

    let data = {
      shipmentTypeId: shipmentTyCategory.id,
      projectId: selectedProject.id,
      shipmentId: serialNo.id,
      status: 1,
    };
    if (isEdit) {
      data = {
        id: editRecord.pihShipmentId,
        data: data,
      };
    }

    setAddLoading(true);
    const res = await OnAddorUpdateShipmentsDashboard(data, isEdit);

    if (res) await OnfetchData();
    else {
      notification.warning({
        message: `${shipmentType} and ${ShipmentNumber} already exists.!`,
      });
    }

    setAddLoading(false);
    setShipmentType('');
    setShipmentNumber('');
    setIsEdit(false);
    setShowAddModel(false);
  };

  /** Resetting values on Closing Modal */
  const handleCancel = () => {
    setShowAddModel(false);
    setShipmentType('');
    setShipmentNumber('');
    setIsEdit(false);
    //equipTypeForm.resetFields();
  };

  return (
    <div>
      <Modal
        className="pipeline-modal"
        title={isEdit ? 'Update Shipment Data' : 'Add New Shipment Data'}
        centered
        visible={showAddModel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>
            {'Cancel'}
          </Button>,
          <Button key="apply" type="primary" onClick={handleOk} loading={addLoading}>
            {isEdit ? 'Update' : 'Add'}
          </Button>,
        ]}
      >
        <Form
          form={equipTypeForm}
          name="basic"
          layout="vertical"
          autoComplete="off"
          getContainer={false}
        >
          <Row gutter={24}>
            <Col lg={12}>
              <Form.Item label="Shipment Type" name="Shipment Type" required>
                <div>
                  <Select
                    className="client-select"
                    placeholder="Select  Shipment type"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    onChange={onChangeShipmentType}
                    value={shipmentType == '' ? null : shipmentType}
                  >
                    {adminShipmentTypesList &&
                      adminShipmentTypesList.map((item, i) => (
                        <Option key={i} value={item && item.name}>
                          {item && item.name}
                        </Option>
                      ))}
                  </Select>
                </div>
              </Form.Item>
            </Col>
            <Col lg={12}>
              <Form.Item label="Shipment Number" name="shipmentNumbe" required>
                <div>
                  <Select
                    className="client-select"
                    placeholder="Select  shipment number"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    onChange={onChangeShipmentSerialNumber}
                    disabled={shipmentType == ''}
                    value={ShipmentNumber == '' ? null : ShipmentNumber}
                  >
                    {serialNoLoading ? (
                      <Option key={'loading'} value={'Loading...'} />
                    ) : (
                      serialNoList &&
                      serialNoList.map((item, i) => (
                        <Option key={i} value={item && item.shipmentNumber}>
                          {item && item.shipmentNumber}
                        </Option>
                      ))
                    )}
                  </Select>
                </div>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default AddNewShipments;
